document.addEventListener('alpine:init', () => {
    Alpine.data('parallaxImage', () => ({
        scrollY: 0,
        scale: 1.2, // scale the image to be larger than the container
        imageStyle: {
            transform: 'translateY(0)',
        },

        init() {
            window.addEventListener('scroll', () => this.handleScroll());
            this.updateImageStyle();
        },

        handleScroll() {
            this.scrollY = window.scrollY;
            this.updateImageStyle();
        },

        updateImageStyle() {
            const translateY = this.scrollY * 0.2; // Adjust the factor for desired effect
            
            this.imageStyle = {
                transform: `translateY(${translateY}px) scale(${this.scale})`,
            };
        },
    }));
});
